import React, { Fragment } from 'react';
import PackageOption from './PackageOption';
import {
  AccordionContent,
  AccordionGroup,
  AccordionHeader
} from 'core/controls';

const PackageOptionGroup = ({
  id,
  header,
  options,
  cashAllowanceSelected,
  onChange
}) => {
  if (options.length === 0) {
    return null;
  }

  const optionList = options.map(option => (
    <PackageOption
      key={option.id}
      option={option}
      cashAllowanceSelected={cashAllowanceSelected}
      onChange={onChange}
    />
  ));

  return (
    <AccordionGroup id={id}>
      <Fragment>
        <AccordionHeader analyticsKey={header}>
          {header} ({options.length})
        </AccordionHeader>
        <AccordionContent>{optionList}</AccordionContent>
      </Fragment>
    </AccordionGroup>
  );
};

export default PackageOptionGroup;
